<ziro-top-nav></ziro-top-nav>
<div class="ziro-add-user-page-content">
  <div class="container-fluid animate__animated animate__fadeIn">
    <div class="col-md-8 offset-md-2">
      <ziro-breadcrumbs></ziro-breadcrumbs>
      <ziro-collapsible-section-card [hidden]="isLoading" [isSwitchHidden]="true" [isCollapsible]="false">
        <ziro-select [fieldId]="'cucmServer'"></ziro-select>
        <ziro-text [fieldId]="'userName'"></ziro-text>
        <ziro-text [fieldId]="'firstName'"></ziro-text>
        <ziro-text [fieldId]="'lastName'"></ziro-text>
      </ziro-collapsible-section-card>
    </div>
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
